const ondcOnboarding = {

    title: "Your ONDC Onboarding Journey",
    subtitle: "Leverage Mperito as TSP to make it Simple, Fast, Effective",
    steps: [
        {
            label: "01",
            title: "Share Basic Business Details",
            description: "Provide your business name, GSTIN, PAN, bank account information, and pickup address. We handle the paperwork and verification process required by ONDC.",
            icon: (<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                <text x="4" y="16" fontSize="16" fill="currentColor" fontFamily="Arial" fontWeight="bold">01</text>
            </svg>)
        },
        {
            label: "02",
            title: "Digitise Your Catalogue",
            description: "Send us your product information, including pricing, images, and descriptions. Our team formats everything according to ONDC's strict standards and taxonomy requirements.",
            icon: (
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                    <text x="4" y="16" fontSize="16" fill="currentColor" fontFamily="Arial" fontWeight="bold">02</text>
                </svg>
            )
        },
        {
            label: "03",
            title: "Complete ONDC Registration",
            description: "We register your business on the ONDC network and secure your unique seller ID. This officially makes you part of India's open commerce revolution.",
            icon: (<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                <text x="4" y="16" fontSize="16" fill="currentColor" fontFamily="Arial" fontWeight="bold">03</text>
            </svg>)

        }
    ]

}

export default ondcOnboarding;